import { SelectOptionType } from '@octano/global-ui';
import { useSurveyLoader } from '../../SurveyCreate/parts/SurveyCreateLoader';
import FormContainer, { FormValues } from '../../SurveyCreate/parts';
import DisplayError from '../../../../../../components/info/DisplayError';
import SurveyPublishedEditLoader from './SurveyPublishedEditLoader';
import { SurveyStatus } from '../../../types/Survey';

export default function SurveyPublishedEdit() {
  const { data } = useSurveyLoader();

  return (
    <SurveyPublishedEditLoader>
      {({ survey, refresh }) => {
        if (!survey || !data) {
          return (
            <DisplayError
              insideCard
              textBody="No se cargaron los datos"
              retryAction={refresh}
            />
          );
        }

        const contextOptions: SelectOptionType[] = data.surveyContexts.map(
          (c) => ({ label: c.name, value: c.id }),
        );
        const periodOptions: SelectOptionType[] = data.periods.map((p) => ({
          label: p.name,
          value: p.id,
          startDate: p.startDate,
          endDate: p.endDate,
        }));
        const scaleOptions: SelectOptionType[] = data.scales.map((s) => ({
          label: s.title,
          value: s.id,
        }));

        const defaultValues: Partial<FormValues> = {
          id: survey.id,
          title: survey.title,
          context:
            contextOptions.find((opt) => opt.value === survey.context) ?? null,
          period:
            periodOptions.find((opt) =>
              survey?.surveyPeriod?.some((sp) => sp?.period?.id === opt.value),
            ) ?? null,
          startDate: survey.startDate,
          endDate: survey.endDate,
          scale:
            scaleOptions.find(
              (opt) =>
                opt.value ===
                survey?.sections[0]?.questions[0]?.evaluationScale?.id,
            ) ?? null,
          sections: survey.sections.map((section) => ({
            id: section.id,
            title: section.name,
            description: section.description ?? '',
            order: section.order,
            questions: section.questions,
          })),
        };

        const isFinished = survey.status === SurveyStatus.Finished;

        return (
          <FormContainer
            defaultValues={defaultValues}
            isPublished={true}
            isFinished={isFinished}
          />
        );
      }}
    </SurveyPublishedEditLoader>
  );
}
